import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import CreateSurvey from './CreateSurvey'
import { SURVEY_PATHS } from './SurveyConstants'
import Loading from 'egret/components/EgretLoadable/Loading'

const SurveyTab = EgretLoadable({
  loader: async () => await import('./SurveyTab')
})

const SurveyScore = EgretLoadable({
  loader: async () => await import('./SurveyScore')
})

const SurveyTemplateList = EgretLoadable({
  loader: async () => await import('./SurveyTemplates')
})

const AvaliableSurveys = EgretLoadable({
  loader: async () => await import('./AvaliableSurveys')
})

const ESATSurveys = EgretLoadable({
  loader: async () => await import('./ESATSurveys')
})

const SurveyScoreCards = EgretLoadable({
  loader: async () => await import('./SurveyScoreCards')
})

const ScoreCardCreator = EgretLoadable({
  loader: async () => await import('./ScoreCardCreator')
})

const FormPage = EgretLoadable({
  loader: async () => await import('../forms/editor/FormWizard')
})

const surveyRoutes: RouteConfig[] = [
  {
    path: SURVEY_PATHS.SAMPLE_SURVEY,
    component: SurveyTab,
    auth: authRoles.admin
  },
  {
    path: SURVEY_PATHS.SCORE_CARDS,
    component: SurveyScoreCards,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SCORE_CARDS_LABEL</Trans>
  },
  {
    path: `${SURVEY_PATHS.SCORE_CARD_CREATOR}/:templateId/:scoreCardId`,
    component: ScoreCardCreator,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SCORE_CARDS_EDITOR_LABEL</Trans>
  },
  {
    path: SURVEY_PATHS.SURVEY_TEMPLATES,
    component: SurveyTemplateList,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_SCORE_LABEL</Trans>
  },
  {
    path: SURVEY_PATHS.SELF_ASSESSMENT_SURVEYS,
    component: AvaliableSurveys,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SELF_ASSESSMENT_TOOL_LABEL</Trans>
  },
  {
    path: SURVEY_PATHS.ESAT,
    component: ESATSurveys,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_ENVIRONMENTAL_SELF_ASSESSMENT_TOOL_LABEL</Trans>
  },
  {
    path: `${SURVEY_PATHS.SURVEY_SCORE}/:id/:templateId?/:scoreCardId?`,
    component: SurveyScore,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_SCORE_LABEL</Trans>
  },
  {
    path: `${SURVEY_PATHS.CREATE_SURVEY}/:id/:templateType`,
    component: CreateSurvey,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>SURVEY_ROUTES_SURVEY_TEMPLATE_EDITOR_LABEL</Trans>
  },
  {
    path: SURVEY_PATHS.CREATE_SURVEY,
    component: CreateSurvey,
    auth: authRoles.editor,
    exact: true
  },
  {
    path: `${SURVEY_PATHS.FORM_PAGE}/:id?`,
    component: FormPage
  }
]

export default surveyRoutes
